import React from "react";
import { ShieldCheck, FileSearch, Users, ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const services = [{
  title: "Pre-Matrimonial Due Diligence",
  description: "Start with complete understanding before you commit. We bring together essential insights from publicly available information: financial, social, and personal, so your next chapter rests on informed conviction",
  icon: ShieldCheck,
  link: "/GetClarityPage"
}, {
  title: "Post-Matrimonial Clarity",
  description: "Gain perspective where it truly matters.\nThrough a thorough and balanced review, we offer clear insight, so you can move ahead feeling certain and at ease.",
  icon: FileSearch,
  link: "/GetClarityPage"
}, {
  title: "Private Consultation",
  description: "Confidential guidance for sensitive situations. Receive tailored strategies and expert advice in a secure environment. Your privacy is our absolute priority.",
  icon: Users,
  link: "/GetClarityPage"
}];
export default function OurAreasOfExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="our-areas-of-expertise" ref={ref} className="bg-background py-24 relative overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div className={`max-w-3xl mx-auto text-center mb-16 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif text-primary mb-6 tracking-tight">
            Our Areas of Expertise
          </h2>
          <p className="text-muted-foreground text-lg md:text-xl font-sans max-w-2xl mx-auto leading-relaxed">
            We provide clarity where it matters most, offering professional verification services tailored to your need for truth and discretion.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 lg:gap-10">
          {services.map((service, index) => <div key={index} data-index={index} className={`transition-all duration-700 delay-${index * 150} ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              <Card className="h-full bg-secondary/40 border border-transparent hover:border-[var(--chart-2)] hover:shadow-lg transition-all duration-300 group flex flex-col justify-between rounded-xl overflow-hidden">
                <CardHeader className="pb-4 pt-8 px-8">
                  <div className="mb-6 inline-flex items-center justify-center size-12 rounded-full bg-background text-primary shadow-sm group-hover:scale-110 transition-transform duration-300">
                    <service.icon className="size-6" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="font-serif text-2xl text-primary leading-tight group-hover:text-primary/80 transition-colors">
                    {service.title}
                  </CardTitle>
                </CardHeader>
                <CardContent className="px-8 pb-8 flex-grow">
                  <p className="text-muted-foreground leading-relaxed font-sans text-base">
                    {service.description}
                  </p>
                </CardContent>
                <CardFooter className="px-8 pb-8 pt-0">
                  <Button asChild variant="ghost" className="p-0 h-auto font-medium text-primary hover:text-[var(--chart-2)] hover:bg-transparent group/btn transition-colors">
                    <Link to={service.link}>
                      <span className="border-b border-primary/30 pb-0.5 group-hover/btn:border-[var(--chart-2)] transition-colors">
                        View Scope
                      </span>
                      <ArrowRight className="ml-2 size-4 transition-transform group-hover/btn:translate-x-1" />
                    </Link>
                  </Button>
                </CardFooter>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}